module.exports = __webpack_public_path__ + "static/media/close-circle.d74fcf48.svg";